import { Footer } from "./Footer";
import { Header } from "./Header";
import ScrollToTop from "./ScrollTop";
import { useLanguageDetection } from "../hooks";
import { Contacts, LogoBanner } from ".";

export function UiWrapper({ children }) {
  useLanguageDetection();
  return (
    <>
      <ScrollToTop />
      <Header />
      {children}
      <LogoBanner />
      <Contacts />
      <Footer />
    </>
  );
}
